// The ONE sanctioned secure-ls import site (contract 06 §15). The localStorage adapter for the
// authStore's persisted keys. An unreadable/tampered blob returns null (fail-safe → the user is
// treated as logged out, no crash — contract 06 §14).
import SecureLS from 'secure-ls'

// secure-ls ships a webpack-UMD CJS bundle whose module.exports is
// { __esModule, default: class }. Vite's production (rolldown) CJS interop is
// node-mode — this default import receives that whole exports object — while
// dev/vitest (esbuild prebundle) receive the class itself. Resolve both to the
// constructor; without this, `new SecureLS(...)` throws "not a constructor" in
// production builds only, so every secure-ls-backed store silently stops
// persisting (staging reload-logout, 2026-07-17).
const SecureLSCtor: typeof SecureLS =
  (SecureLS as unknown as { default?: typeof SecureLS }).default ?? SecureLS

let ls: SecureLS | null = null
function secure(): SecureLS {
  // FROZEN wire contract — these options must stay byte-identical to v3's
  // `new SecureLS({ isCompression: false })` (v3 authStore.ts:11), because v3 and v4 read each
  // other's session blob across the proxy split. Omitting `encodingType` is DELIBERATE: it
  // defaults to Base64, and v3 relies on that default. Adding `encodingType: 'aes'` here makes
  // the v3-written blob unreadable and logs every user out. See sessionCutover.spec.ts.
  ls ??= new SecureLSCtor({ isCompression: false })
  return ls
}

/** pinia-plugin-persistedstate storage backend (sync getItem/setItem/removeItem). */
export const secureStorage = {
  getItem(key: string): string | null {
    try {
      const value = secure().get(key)
      return value === '' ? null : value
    } catch {
      return null // tampered / decrypt failure — fail safe
    }
  },
  setItem(key: string, value: string): void {
    try {
      secure().set(key, value)
    } catch (cause) {
      // A swallowed write is silent session loss on the next reload — keep the
      // failure observable while staying fail-safe (contract 06 §14).
      console.warn('[auth] secure-ls write failed; the session will not persist.', cause)
    }
  },
  removeItem(key: string): void {
    secure().remove(key)
  },
}
